/* eslint-disable no-unused-expressions */
import React from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../../utility/Constant";

const WorkforceContentPage = () => {
  const { workforceApi } = apiPath;
  const { clientServices } = clientSideUrl;
  const [workforceContentData, workforceContentLoading] =
    useFetch(workforceApi);

  if (workforceContentLoading) {
    return <Loading />;
  }

  const bannerContent = workforceContentData?.find(
    (item) => item.Slug === "banner"
  );

  if (!bannerContent?._id) {
    return <div className="p-5">No workforce banner content found.</div>;
  }

  const { Banner_image, Banner_Title, _id } = bannerContent;

  const data = [
    {
      elementType: "input",
      label: "Banner title",
      type: "Text",
      name: "Banner_Title",
      defaultValue: Banner_Title,
      required: false,
    },
    /* {
      elementType: "textField",
      label: "Banner description",
      type: "Text",
      name: "Banner_Description",
      defaultValue: Banner_Description,
      required: false,
    }, */
    {
      elementType: "file",
      label: `Banner Image`,
      name: "Banner_image",
      type: "file",
      fullCol: true,
      defaultValue: Banner_image,
      required: false,
    },
  ];

  const update = (data) => {
    const { Banner_image, ...rest } = data;
    rest.Banner_image = {
      url: Banner_image,
    };
    rest.Slug = "banner";
    updateData(workforceApi, rest, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientServices}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        <h1 className="md:ml-8 font-oswald font-bold text-2xl mt-4  uppercase">
          banner content
        </h1>

        <GlobalForm data={data} update={update} />
      </div>
    </div>
  );
};

export default WorkforceContentPage;

